module.exports = __webpack_public_path__ + "img/ITA.46e4481c.svg";